// extracted by mini-css-extract-plugin
export default {"main_header":"Header_main_header__jxp9-","logo":"Header_logo__nZ7K6"};